import { propertyType, t } from '@blocksuite/data-view';
import { DATABASE_ROW_SYSTEM_FIELD_NAMES } from '@streamlain/database-identity';
import { format } from 'date-fns/format';
import zod from 'zod';

export const updatedTimeColumnType = propertyType('updated-time');
export const updatedTimePropertyModelConfig = updatedTimeColumnType.modelConfig(
  {
    name: DATABASE_ROW_SYSTEM_FIELD_NAMES['updated-time'],
    propertyData: {
      schema: zod.object({}),
      default: () => ({}),
    },
    jsonValue: {
      schema: zod.number().nullable(),
      isEmpty: () => false,
      type: () => t.date.instance(),
    },
    rawValue: {
      schema: zod.number().nullable(),
      default: () => null,
      toString: ({ value }) =>
        value != null ? format(value, 'yyyy-MM-dd HH:mm:ss') : '',
      fromString: () => {
        return { value: null };
      },
      toJson: ({ value }) => value,
      setValue: () => {},
    },
    fixed: {
      defaultData: {},
      defaultShow: false,
    },
  }
);
